import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Battery5BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_5_bar"}/>
}
